// @flow
import * as React from 'react';
import styled from 'styled-components';

type TProps = {
  children: string | React.Node,
  color?: string,
};

const StyledParagraph = styled.p`
  font-family: InterRegular;
  line-height: 1.6;
  font-size: 16px;
  margin-top: .4rem;
  color: ${props => props.color || '#4b4b4b'};
  text-align: ${props => props.centered ? 'center' : (props.align || 'left')};
`;

export default function TextParagraph(props: TProps): React.Node {
  return (
    <StyledParagraph {...props}>
      {props.children}
    </StyledParagraph>
  );
}
